




















import {Component, Prop, Vue} from 'vue-property-decorator';
import Database from "@/modules/firebase";

@Component
class Control extends Vue {
    @Prop() private message!: string;
    active: boolean | null;
    error: string | null;
    token: string;
    webcamera: string | null;
    snapshot: any;
    timeout: boolean;

    constructor() {
        super();
        this.active = null;
        this.snapshot = null;
        this.webcamera = null;
        this.error = null;
        this.token = '';
        this.timeout = true;
    }

    beforeMount() {
        const {token} = this.$route.query;
        if (typeof token == 'string') {
            this.token = token;
        } else {
            this.error = "Token missed";
        }
    }

    mounted() {
        const data = Database.getTokenData(this.token).on('value', (snapshot: any) => {
            if (snapshot.val() === null) {
                this.error = "Token invalid";
                this.$forceUpdate();
            }
            this.snapshot = snapshot.val();
            const {status, settings} = snapshot.val();
            this.active = status;
            if(settings && settings.webcamUrl !== undefined) {
                this.webcamera = settings.webcamUrl;
                setInterval(() => {
                    this.webcamera = settings.webcamUrl + '?' + new Date().getTime();
                }, 3000);
            }
            this.$forceUpdate();
        });
    }

    handleVideoStream(e: Event) {
        if(e.returnValue) {
            this.webcamera = null;
        }
    }

    changeStatus() {
        console.log(this.snapshot)
        if(this.snapshot !== null) {
            this.snapshot.status = !this.active
            Database.getTokenData(this.token).set(this.snapshot);
        }
        if(this.timeout && this.active === true && this.snapshot.settings.automaticStop && this.snapshot.settings.automaticStop.timeout && this.snapshot.settings.automaticStop.enabled === true) {
            setTimeout(() => {
                if(this.active === true) {
                    this.snapshot.status = !this.active
                    Database.getTokenData(this.token).set(this.snapshot);
                }
                this.timeout = true;
            }, this.snapshot.settings.automaticStop.timeout * 1000);
            this.timeout = false;
        }
    }
}

export default Control;
